import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";

export function useUrlSyncedState() {
  const [searchParams, setSearchParams] = useSearchParams();

  const getParam = useCallback(
    (key: string) => searchParams.get(key),
    [searchParams]
  );

  const getParams = useCallback(
    (keys: string[]) => {
      return keys.reduce<Record<string, string | null>>((acc, key) => {
        acc[key] = searchParams.get(key);
        return acc;
      }, {});
    },
    [searchParams]
  );

  const updateParams = useCallback(
    (params: Record<string, string | undefined | null>, replace = true) => {
      const newSearchParams = new URLSearchParams(searchParams);

      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          newSearchParams.set(key, value);
        } else {
          newSearchParams.delete(key);
        }
      });

      setSearchParams(newSearchParams, { replace });
    },
    [searchParams, setSearchParams]
  );

  const clearParams = useCallback(
    (keys: string[], replace = true) => {
      const newSearchParams = new URLSearchParams(searchParams);

      keys.forEach((key) => {
        newSearchParams.delete(key);
      });

      setSearchParams(newSearchParams, { replace });
    },
    [searchParams, setSearchParams]
  );

  return {
    searchParams,
    getParam,
    getParams,
    updateParams,
    clearParams,
  };
}
